import { TableHTMLAttributes } from 'react';

export type TableProps = TableHTMLAttributes<HTMLTableElement>;

export const Table = (props: TableProps) => <table {...props} />;
